import { render, staticRenderFns } from "./RDataTable.vue?vue&type=template&id=4952c8b0&scoped=true&"
import script from "./RDataTable.vue?vue&type=script&lang=js&"
export * from "./RDataTable.vue?vue&type=script&lang=js&"
import style0 from "./RDataTable.vue?vue&type=style&index=0&id=4952c8b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952c8b0",
  null
  
)

export default component.exports